import React, { useEffect, useState, useContext, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { LanguageContext } from "../context/language/LanguageContext";
import { alertActions } from "../store/alertSlice";
import appConst from "../Utilities/appConst.json";
import { footerActions } from "../store/footerSlice";
import { modeActions } from "../store/modeSlice";
import { loaderActions } from "../store/loaderSlice";
import "../styles/basket.css";
import ItemsDeletionStripe from "../Components/ItemsDeletionStripe";
import {
  fetchShippingMethodsData,
  shippingActions,
} from "../store/shippingSlice";
import {
  basketActions,
  getBasketData,
  deleteBasketItems,
} from "../store/basket";
import EMOJI_SMILE from "../img/emoji_smile.svg";
import CustomMarketingStripe from "../shared/CustomMarketingStripe";
import { useHistory } from "react-router-dom";
import stepper from "../Utilities/stepperUtil";
import BasketItem from "../Components/BasketItem";
import CustomAlert from "../shared/CustomAlert";
import { disableButton, enableButton } from "../Utilities/styleUtil";
import AddButton from "../shared/AddButton";
import { fetchAllCities } from "../store/citiesSlice";
import useBrazeScreenView from "../hooks/useBrazeScreenView";
import PageLayout from "../Components/PageLayout";

let flag_ga4 = true;
let single = true;

const Basket = () => {
  useBrazeScreenView();
  const dispatch = useDispatch();
  const languageContext = useContext(LanguageContext);
  const history = useHistory();
  const myElementRef = useRef(null);
  const beforeContinueRef = useRef(null);
  // Step index of the last visited route, to tell a forward POP from a Back POP.
  const lastStepRef = useRef(stepper.get(window.location.pathname));
  const innerHeight = window.innerHeight;

  const product = sessionStorage.getItem(appConst.PRODUCT); //appConst.ORDERS_UNION
  const basket = useSelector((state) => state.basket.basket);
  const basketItems = useSelector((state) => state.basket.basketItems);
  const totalCopiesAdditionOrRemoved = useSelector(
    (state) => state.basket.totalCopiesAdditionOrRemoved
  );
  const copyAdditionOrRemoval = useSelector(
    (state) => state.basket.copyAdditionOrRemoval
  );
  const stripeText = useSelector((state) => state.basket.stripeText);
  const footerContentHeight = useSelector(
    (state) => state.footer.footerContentHeight
  );
  const guardIndex = useSelector((state) => state.guard.guardIndex);
  const isNewsletter = useSelector((state) => state.user.isNewsletter);
  const showAlert = useSelector((state) => state.basket.showAlert);
  // const isShowUpdated = useSelector((state) => state.loader.isShowUpdated);
  const isShowUpdated = useSelector((state) => state.footer.summary.quantity);
  const [selctedItemsQuantity, setSelctedItemsQuantity] = useState(0);
  const [totalItemsToDeleteQuantity, setTotalItemsToDeleteQuantity] =
    useState(0);
  const [selectAll, setselectAll] = useState(false);
  const [callbackDeleteFromStore, setCallbackDeleteFromStore] = useState(null);
  const [callbackDeleteFromServer, setCallbackDeleteFromServer] =
    useState(null);
  const [isDeletionMode, setIsDeletionMode] = useState(false);
  const [hasScroller, setHasScroller] = useState(false);

  useEffect(() => {
    dispatch(basketActions.setBasketToolbarVisible(true));
    dispatch(footerActions.setIsShow(true));
    dispatch(footerActions.setNextPage(""));
    dispatch(
      footerActions.setBtnText(
        languageContext.getTranslation(appConst.TO_FIFTH_PAGE)
      )
    );
    dispatch(footerActions.setDisable(product === appConst.ORDERS_UNION));
    dispatch(footerActions.setBeforeContinue(beforeContinue));
    dispatch(
      footerActions.setTempFooterFromShipping({
        tempAdditionalDiscount: null,
        tempTotal: null,
        shipping: null,
      })
    );
    dispatch(footerActions.setDisable(true));

    dispatch(alertActions.closeAlert());

    // Reset shipping methods
    dispatch(shippingActions.setShippingMethods([]));

    dispatch(fetchAllCities());

    if (single) {
      dispatch(getBasketData(product, isNewsletter));
      single = false;
    }

    return () => {
      dispatch(basketActions.setBasketToolbarVisible(false));
      dispatch(basketActions.setMarketingStripeVisible(false));
    };
  }, []);

  useEffect(() => {
    if (callbackDeleteFromStore) {
      callbackDeleteFromStore();
      setCallbackDeleteFromStore(null);
    }
  }, [callbackDeleteFromStore]);

  useEffect(() => {
    if (callbackDeleteFromServer) {
      callbackDeleteFromServer();
      setCallbackDeleteFromServer(null);
    }
  }, [callbackDeleteFromServer]);

  useEffect(() => {
    const hasBasketItems = basketItems?.length > 0;
    // Keep the continue button disabled until the basket items have loaded.
    dispatch(footerActions.setDisable(!hasBasketItems));
  }, [basketItems]);

  useEffect(() => {
    if (!basketItems || basketItems.length === 0) {
      dispatch(loaderActions.loaderShow());
    } else {
      const quantitySummary = basketItems.reduce(
        (previousValue, currentValue) => previousValue + currentValue.quantity,
        0
      );
      const priceListSummary = basketItems.reduce(
        (previousValue, currentValue) =>
          previousValue + currentValue.price_list * currentValue.quantity,
        0
      );
      const quantityDiscountSummary = basketItems.reduce(
        (previousValue, currentValue) =>
          previousValue +
          currentValue.quantity_discount * currentValue.quantity,
        0
      );
      const additionalDiscountSummary = basketItems.reduce(
        (previousValue, currentValue) =>
          previousValue +
          currentValue.additional_discount * currentValue.quantity,
        0
      );
      const totalSummary = basketItems.reduce(
        (previousValue, currentValue) =>
          priceListSummary -
          quantityDiscountSummary -
          additionalDiscountSummary,
        0
      );

      dispatch(
        footerActions.setFooterFromBasket({
          quantity: quantitySummary,
          quantityDiscount: quantityDiscountSummary,
          additionalDiscount: additionalDiscountSummary,
          total: totalSummary,
          priceList: priceListSummary,
          shipping: null,
        })
      );

      if (
        product === appConst.BOOKS &&
        basketItems.some((item) => item.is_valid == false)
      ) {
        disableButton(dispatch);
        dispatch(footerActions.setDisable(true));
        dispatch(footerActions.setNextPage(""));
        dispatch(footerActions.setShowPrices(false));
      } else {
        enableButton(dispatch);
        dispatch(footerActions.setDisable(false));
        dispatch(footerActions.setNextPage(appConst.FIFTH_PAGE));
        dispatch(footerActions.setShowPrices(true));
      }

      dispatch(footerActions.setBeforeContinue(beforeContinue));

      if (flag_ga4) {
        flag_ga4 = false;
        dispatch(
          modeActions.setValueGA4({ value: appConst.to_the_shopping_cart })
        );
      }

      const elementHeight = myElementRef.current?.clientHeight;
      setHasScroller(elementHeight > innerHeight);

      // Hide loader after delete
      dispatch(loaderActions.loaderHide());
    }
  }, [basketItems]);

  useEffect(() => {
    if (!isDeletionMode) {
      return;
    }
    setTotalItemsToDeleteQuantity((prev) => prev + copyAdditionOrRemoval);
  }, [totalCopiesAdditionOrRemoved, isDeletionMode]);

  useEffect(() => {
    const unlisten = history.listen((location) => {
      const newStep = stepper.get(location.pathname);

      if (history.action === "POP") {
        const prevStep = lastStepRef.current;
        if (newStep != null && prevStep != null && newStep > prevStep) {
          beforeContinueRef.current?.();
        }
      }

      if (newStep != null) {
        lastStepRef.current = newStep;
      }
    });

    return () => {
      unlisten();
    };
  }, [history]);

  useEffect(() => {
    const isStripeVisible = !isDeletionMode && !showAlert && !!stripeText;
    dispatch(basketActions.setMarketingStripeVisible(isStripeVisible));
  }, [isDeletionMode, showAlert, stripeText, dispatch]);

  const changeIsChecked = (e, id) => {
    dispatch(
      basketActions.setBasketItemsIsChecked({
        value: e,
        index: id,
        product: product,
      })
    );
  };

  const handleSelectedAll = (event) => {
    setselectAll(event.target.checked);
    let newSelctedItemsQuantity = 0;
    let itemsToDeleteQuantityCounter = 0;
    for (const item of basketItems) {
      if (item.isChecked != event.target.checked) {
        changeIsChecked(event.target.checked, item.item_id);
        newSelctedItemsQuantity++;
        itemsToDeleteQuantityCounter += item.quantity;
      }
    }
    if (isDeletionMode) {
      updateItemsQuantityForDeletion(
        event.target.checked,
        newSelctedItemsQuantity,
        itemsToDeleteQuantityCounter
      );
    }
  };

  const updateItemsQuantityForDeletion = (
    isChecked,
    newSelctedItemsQuantity,
    additionOrRemovalitemsToDeleteQuantity
  ) => {
    setSelctedItemsQuantity((prevSelected) => {
      const nextSelected = isChecked
        ? prevSelected + newSelctedItemsQuantity
        : prevSelected - newSelctedItemsQuantity;

      if (isChecked && nextSelected === basketItems.length) {
        setselectAll(true);
      }

      if (!isChecked) {
        setselectAll(false);
      }

      return nextSelected;
    });

    setTotalItemsToDeleteQuantity((prevTotal) => {
      return isChecked
        ? prevTotal + additionOrRemovalitemsToDeleteQuantity
        : prevTotal - additionOrRemovalitemsToDeleteQuantity;
    });
  };

  const setSelectedValue = (e, id, quantity) => {
    changeIsChecked(e, id);
    if (isDeletionMode) {
      updateItemsQuantityForDeletion(e, 1, quantity);
    }
  };

  const resetDeletionSelection = () => {
    setselectAll(false);
    setSelctedItemsQuantity(0);
    setTotalItemsToDeleteQuantity(0);
    dispatch(basketActions.resetBasketItemsIsChecked());
  };

  const toggleDeletionMode = () => {
    resetDeletionSelection();
    setIsDeletionMode((prev) => !prev);
  };

  const alertSelectedYes = () => {
    const selectedItemsIds = [
      ...basketItems
        .filter((item) => item.isChecked === true)
        .map((item) => item.item_id),
    ];

    setCallbackDeleteFromServer(function () {
      dispatch(loaderActions.loaderShow());
      dispatch(deleteBasketItems(selectedItemsIds, product, isNewsletter));
    });

    updateItemsQuantityForDeletion(
      false,
      selectedItemsIds.length,
      selectedItemsIds.length
    );
  };

  const beforeDeleting = () => {
    dispatch(
      alertActions.createAlert({
        title: languageContext.getTranslation(appConst.EXCUSE_ME),
        message: languageContext.getTranslation(appConst.SURE_DELETE),
        isDialog: true,
        funcYes: () => {
          alertSelectedYes();
          setTimeout(() => {
            setselectAll(false);
            setSelctedItemsQuantity(0);
            setTotalItemsToDeleteQuantity(0);
            setIsDeletionMode(false);
          }, 0);
        },
        yesButtonText: appConst.YES,
        noButtonText: appConst.NO,
      })
    );
  };

  const selectedAll = () => {
    if (selctedItemsQuantity === basketItems.length) {
      return true;
    } else {
      return selectAll;
    }
  };

  const beforeContinue = () => {
    dispatch(basketActions.resetBasketItemsIsChecked());

    switch (product) {
      case appConst.ORDERS_UNION:
        if (basketItems.some((item) => item.is_valid == false)) {
          dispatch(basketActions.setShowAlert(true));
        } else {
          const checkedBasketItems = basketItems.filter(
            (item) => item.isChecked == true
          );
          dispatch(
            fetchShippingMethodsData({
              ...basket,
              items: checkedBasketItems,
            })
          );
        }
        break;
      default:
        dispatch(fetchShippingMethodsData(basket));
        break;
    }
  };

  // Keep the ref pointing at the current beforeContinue (with the loaded basket).
  beforeContinueRef.current = beforeContinue;

  return (
    <>
      {isShowUpdated && (
        <PageLayout data-testid="basket-page">
          {!isDeletionMode && !showAlert && stripeText && (
            <CustomMarketingStripe
              text={languageContext.getTranslation(stripeText)}
              boldText={languageContext.getTranslation(
                appConst.MARKETING_STRIPE_TEXT_BOLD
              )}
              icon={EMOJI_SMILE}
            />
          )}
          <ItemsDeletionStripe
            isDeletionMode={isDeletionMode}
            selectedAll={selectedAll}
            countSelectedItems={totalItemsToDeleteQuantity}
            beforeDeleting={beforeDeleting}
            selectAll={selectAll}
            handleSelectedAll={handleSelectedAll}
            product={product}
            hasScroller={hasScroller}
            onToggleDeletionMode={toggleDeletionMode}
            isStripeVisible={!isDeletionMode && !showAlert && !!stripeText}
          />
          {!isDeletionMode && product === appConst.ORDERS_UNION && (
            <div className="orders_union_note basket_page">
              <div>
                {languageContext.getTranslation(appConst.CHECK_TO_UNION_ORDERS)}
              </div>
            </div>
          )}
          {showAlert && (
            <CustomAlert
              text={languageContext.getTranslation(appConst.BASKET_ERROR_ALERT)}
            />
          )}

          <div ref={myElementRef} data-testid="basket-items-list">
            {basketItems.map((item) => (
              <div
                className="sm:mb-6 mb-2 px-4 min-[800px]:px-0"
                key={item.item_id}
                data-testid={`basket-item-wrapper-${item.item_id}`}
              >
                <BasketItem
                  item={item}
                  setSelectedValue={setSelectedValue}
                  product={product}
                  isDeletionMode={isDeletionMode}
                />
              </div>
            ))}
          </div>

          <AddButton footerContentHeight={footerContentHeight} />
        </PageLayout>
      )}
    </>
  );
};
export default Basket;
